/**
 * Client-side encode/decode for agreement Content (UTF-8 HTML ↔ base64).
 * Gracefully falls back when Content is still plaintext (pre-migration).
 */

function utf8ToBase64(str) {
  const bytes = new TextEncoder().encode(str);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function base64ToUtf8(b64) {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new TextDecoder().decode(bytes);
}

function looksLikeHtml(s) {
  if (!s || typeof s !== "string") return false;
  return /<\/?[a-z][\s\S]*>/i.test(s);
}

function looksLikeBase64(s) {
  if (!s || typeof s !== "string") return false;
  const trimmed = s.trim();
  if (trimmed.length < 8 || trimmed.length % 4 !== 0) return false;
  if (looksLikeHtml(trimmed)) return false;
  return /^[A-Za-z0-9+/]+={0,2}$/.test(trimmed);
}

/** HTML string → base64 for API write. */
export function encodeAgreementHtml(html) {
  if (html == null || html === "") return "";
  return utf8ToBase64(String(html));
}

/**
 * API Content (base64) → HTML for display.
 * If value looks like plaintext HTML (legacy), return as-is.
 */
export function decodeAgreementHtml(content) {
  if (content == null || content === "") return "";
  const raw = String(content);
  if (looksLikeHtml(raw)) return raw;
  if (!looksLikeBase64(raw)) return raw;
  try {
    return base64ToUtf8(raw.trim());
  } catch {
    return raw;
  }
}

export default { encodeAgreementHtml, decodeAgreementHtml };
